<template>
    <Modal v-model:visible="visibleAttivo">
        <template v-slot:header>
            <div>
            </div>
        </template>
        <template v-slot:main>
            <div class="pt-5">
                <div class="flex flex-col items-center mb-3">
                    <div class="basis-1/2">
                        <div class="text-center">L'alert manuale è ora attivo il giorno</div>
                        <div class="text-3xl font-bold text-center">{{ date }}</div>
                        <div class="text-center">ed assegnato a</div>

                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="flex justify-center pt-3">
                <NextButton variant="outline-secondary"
                    @click="$emit('update:visibleAttivo', false)"
                    class="col-start-3 py-2 px-4">
                    Chiudi
                </NextButton>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import Modal from "@/components/Modal.vue";
import NextButton from "@/components/NextButton.vue";

@Options({
    name:'ModalAlertAttivo',
    components: {
        NextButton,
        Modal
    },
    props: {
        visibleAttivo: {
            type: Boolean,
            default: true
        },
    }
})
export default class ModalAlertAttivo extends Vue {
    visibleAttivo!: boolean

    date = ''

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
